module.exports = __webpack_public_path__ + "static/media/chausn-logo.73f419be.png";